import { chatConstants } from "./chatActions";

const initialState = {
  conversations: [],
  activeChatId: null,
  unreadCount: 0,
  socketConnected: false,
  typing: {}, // { chatId: { userId: boolean } }
};

export function chat(state = initialState, action) {
  switch (action.type) {
    case chatConstants.SET_CONVERSATIONS:
      return {
        ...state,
        conversations: action.conversations,
      };

    case chatConstants.ADD_CONVERSATION:
      return {
        ...state,
        conversations: [action.conversation, ...state.conversations],
      };

    case chatConstants.UPDATE_CONVERSATION:
      return {
        ...state,
        conversations: state.conversations.map((conv) =>
          conv._id === action.chatId ? { ...conv, ...action.conversation } : conv
        ),
      };

    case chatConstants.SET_ACTIVE_CHAT:
      return {
        ...state,
        activeChatId: action.chatId,
      };

    case chatConstants.ADD_MESSAGE:
      return {
        ...state,
        conversations: state.conversations.map((conv) => {
          if (conv._id === action.chatId) {
            return {
              ...conv,
              messages: [...(conv.messages || []), action.message],
              lastMessage: action.message.content.substring(0, 100),
              lastMessageAt: action.message.createdAt,
            };
          }
          return conv;
        }),
      };

    case chatConstants.MARK_MESSAGES_AS_READ:
      return {
        ...state,
        conversations: state.conversations.map((conv) => {
          if (conv._id === action.chatId) {
            return {
              ...conv,
              messages: (conv.messages || []).map((msg) =>
                !msg.read ? { ...msg, read: true, readAt: new Date() } : msg
              ),
            };
          }
          return conv;
        }),
      };

    case chatConstants.SET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: action.count,
      };

    case chatConstants.SET_SOCKET_CONNECTED:
      return {
        ...state,
        socketConnected: action.connected,
      };

    case chatConstants.SET_TYPING:
      return {
        ...state,
        typing: {
          ...state.typing,
          [action.chatId]: {
            ...state.typing[action.chatId],
            [action.userId]: action.isTyping,
          },
        },
      };

    default:
      return state;
  }
}

